import NiceModal from '@ebay/nice-modal-react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useState } from 'react';

import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { faExpandAlt } from '@fortawesome/pro-regular-svg-icons';

import * as S from './styled/ImageViewer.styled';

/**
 * @author Burak Ak
 */

const ImageViewer = ({ imageUrl, children }) => (
	<S.Miniscreen
		padding={0}
		rounded
		shadowed
		onClick={() => {
			NiceModal.show(ImageModal, { imageUrl: imageUrl ?? children });
		}}>
		<S.DarkContainer>
			<Icon icon={faExpandAlt} color="var(--white)" size="large" />
		</S.DarkContainer>

		<Image url={imageUrl ?? children} width="95%" height="95%" alt="image" referrerPolicy="no-referrer" />
	</S.Miniscreen>
);

export const ImageModal = NiceModal.create(({ imageUrl }) => (
	<Modal className="modal-imageModal" fullwidth>
		<S.ModalContainer>
			<Image url={imageUrl} width="100%" height="100%" alt="image" referrerPolicy="no-referrer" />
		</S.ModalContainer>
	</Modal>
));

export const ImageSliderModal = NiceModal.create(({ imageUrls }) => {
	const [swiper, setSwiper] = useState(null);
	const [activeIndex, setActiveIndex] = useState(0);

	return (
		<Modal className="modal-imageSliderModal" fullwidth>
			<S.ModalContainer>
				<Swiper
					modules={[Navigation]}
					onSwiper={setSwiper}
					onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}>
					<S.NavigationButtonStyled
						className="slider-navigation-left"
						icon={faChevronLeft}
						variant="borderless"
						disabled={activeIndex === 0}
						onClick={() => swiper?.slidePrev()}
					/>
					{imageUrls.map((imageUrl) => (
						<SwiperSlide key={imageUrl}>
							<Image url={imageUrl} alt="image" width="100%" height="100%" />
						</SwiperSlide>
					))}
					<S.NavigationButtonStyled
						className="slider-navigation-right"
						icon={faChevronRight}
						variant="borderless"
						disabled={activeIndex === imageUrls.length - 1}
						onClick={() => swiper?.slideNext()}
					/>
				</Swiper>
			</S.ModalContainer>
		</Modal>
	);
});

export default ImageViewer;
